<div class="d-flex justify-content-between m-phone-wrapper {{customClass}}">
  <input class="m-form-control" maxlength="7" type="tel" placeholder="{{'HELP_DIALOG.PHONE_NUMBER_PC' | translate}}" (keypress)="onKeyPressNumber($event.target.value, $event)"
    (input)="onChangeNumber($event.target.value)" [value]="currentNumber">
  
  <select (change)="onPreChange($event.target.value)" [(ngModel)]="currentPre" class="m-form-control">
    <option [value]="defaultValue">{{'COMMON.PHONE_NUM_PREFIX' | translate}}</option>
    <option *ngFor="let pre of prefixes" [value]="pre">{{ pre }}</option>
  </select>
</div>


// WEBPACK FOOTER //
// ./src/app/phone-number/phone-number.component.html